import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled.ts';

export const useHomeViewedAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { livePageReleasePhase } = useIsLivePagesFeatureEnabled();

	useEffect(() => {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				action: 'viewed',
				actionSubject: 'home',
				source: 'homeScreen',
				attributes: {
					navdexPointType: START_TOUCH,
					livePageReleasePhase,
				},
			},
		}).fire();
	}, [createAnalyticsEvent, livePageReleasePhase]);
};
